module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('z-table', {
    attrs: {
      "offset": _vm.params.offset,
      "count": _vm.params.count,
      "total-count": _vm.list.item_total
    }
  }, [_vm._l((_vm.columns), function(item) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('tr', {
    attrs: {
      "slot": "datasource"
    },
    slot: "datasource"
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0c30afb0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/clear/ClearList.vue
// module id = 814
// module chunks = 0